import Vue from 'vue'
import VueI18n from 'vue-i18n'
import PKG_JSON from "../../package.json"
import elementEnLocale from 'element-ui/lib/locale/lang/en'
import elementZhLocale from 'element-ui/lib/locale/lang/zh-CN'
import enLocale from './en'
import zhLocale from './zh'
import storage from "../../public/static/js/storage";

const K_VERSION = PKG_JSON.version
const K_PROJECT_NAME = PKG_JSON.name
Vue.use(VueI18n)
function getGlobalStorageKeyName(key) {
    //  项目 + 版本号 + key
    return K_PROJECT_NAME + "::" + K_VERSION + "::" + key;
}
const localMessages = {
    zh: {
        ...zhLocale,
        ...elementZhLocale  // 将zhLocal和elementZhLocale两个JSON格式的内容合并成一个JSON格式的内容
    },
    en: {
        ...enLocale,
        ...elementEnLocale   // 将enLocale和elementEnLocale两个JSON格式的内容合并成一个JSON格式的内容 
    },

}
const i18n = new VueI18n({
    locale: storage.get(getGlobalStorageKeyName('language')) || 'zh',
    messages: localMessages,
})
window.i18n = i18n
export { i18n }
